import React from 'react';
import { useStoreState } from 'base/store';
import Script from 'next/script';

//https://developers.google.com/search/docs/advanced/structured-data/sitelinks-searchbox
const WebSiteSchema: React.FC = () => {
    const { host } = useStoreState('rootStore');

    const schema = {
      "@context": "http://schema.org",
      "@type": "WebSite",
      "url": `${host.indexOf('localhost') === -1 ? 'https' : 'http'}://${host}`,
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": `${host.indexOf('localhost') === -1 ? 'https' : 'http'}://${host}/search?q={query}`,
        },
        "query-input": "required name=query"
      }
    };

    return (
        <Script
            id="website-schema"
            type="application/ld+json"
            strategy="beforeInteractive"
            dangerouslySetInnerHTML={{
                __html: JSON.stringify(schema)
            }}
        />
    )
};

export default WebSiteSchema;
